export default __webpack_public_path__ + "static/media/covid-essentials_0.3c415237.jpg";